import React, {useMemo} from 'react'
import {UseFormReturn} from 'react-hook-form'
import {ShipToCreationForm} from './shipToCreationForm.types'
import {ShipToCreationData} from './shipToCreationData'
import {ShipToCreationContext, ShipToCreationContextValue} from './shipToCreationContext'

export type ShipToCreationProviderProps = {
  children: React.ReactNode
  shipToCreationForm: UseFormReturn<ShipToCreationForm>
  processData: ShipToCreationData
}

export const ShipToCreationProvider: React.FC<ShipToCreationProviderProps> = ({
  children,
  shipToCreationForm,
  processData
}) => {
  const contextValue: ShipToCreationContextValue = useMemo(() => {
    return {
      shipToCreationForm,
      processData
    }
  }, [shipToCreationForm, processData])

  return (
    <ShipToCreationContext.Provider value={contextValue}>{children}</ShipToCreationContext.Provider>
  )
}
